import { verticalScale } from '@utils/normalize';
import { StyleSheet, Platform } from 'react-native';

const styles = StyleSheet.create({
  detailsStyle: { flexDirection: 'row', marginTop: verticalScale(4) },
  footerButton: {
    minWidth: 120,
  },
  footerContainer: {
    backgroundColor: 'transparent',
    borderTopWidth: 1,
    paddingHorizontal: 16,
    paddingVertical: verticalScale(8),
  },
  rtsFooter: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
    // Mobile: use space-between for equal distribution
    ...(Platform.OS !== 'web' && {
      justifyContent: 'space-between',
    }),
    // Web-specific styles to handle React Query dev tools overlap
    ...(Platform.OS === 'web' && {
      justifyContent: 'space-between', // Use space-between for full width distribution
      position: 'relative',
      zIndex: 1000,
      paddingRight: 60, // Use padding to avoid React Query dev tools overlap
      minHeight: 80, // Ensure minimum height for proper button display
      width: '100%', // Ensure full width is available
    }),
  },
});
export default styles;
